import React, { useState } from 'react';
import { supabase } from './supabaseClient';

// BORRAMOS LA LÍNEA QUE DECÍA: import AccesoSoloTelefono from './AccesoSoloTelefono';

const AccesoSoloTelefono = ({ onLoginSuccess }) => {
  const [telefono, setTelefono] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleIngreso = async (e) => {
    e.preventDefault();
    if (!telefono.trim()) return alert("Por favor, ingrese un teléfono");
    
    setCargando(true);
    
    // Auditoría de datos en Supabase
    const { data, error } = await supabase
      .from('padres')
      .select('telefono, activo')
      .eq('telefono', telefono.trim())
      .eq('activo', true)
      .single();

    if (error || !data) {
      alert("Teléfono no autorizado.");
      setCargando(false);
    } else {
      onLoginSuccess(data);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="bg-white p-10 rounded-[2.5rem] shadow-2xl w-full max-w-md border-b-[10px] border-blue-600">
        <h1 className="text-4xl font-black text-center mb-2 tracking-tighter text-zinc-900">
          EMACT KIDS
        </h1>
        <p className="text-center text-zinc-400 text-[10px] font-bold uppercase tracking-widest mb-8">
          Acceso por Teléfono
        </p>
        
        <form onSubmit={handleIngreso} className="space-y-6">
          <input
            type="tel"
            placeholder="N° DE CELULAR"
            className="w-full p-5 bg-zinc-50 border-2 border-zinc-100 rounded-2xl text-center text-2xl font-black focus:border-blue-500 outline-none"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            required
          />
          <button 
            disabled={cargando}
            className="w-full bg-blue-600 text-white py-5 rounded-2xl font-black text-lg hover:bg-blue-700 transition-all disabled:opacity-50 uppercase tracking-widest"
          >
            {cargando ? "VALIDANDO..." : "INGRESAR"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccesoSoloTelefono;